import { Action } from '@ngrx/store';

import { HideLoader } from '../../../../shared/decorators/hide-loader';
import { ShowLoader } from '../../../../shared/decorators/show-loader';
import { Country } from '../country.model';

export enum CountriesActionTypes {
    LoadCountries = '[Countries] LoaF',
    LoadCountriesSuccess = '[Countries] Load success',
    LoadCountriesFail = '[Countries] Load fail',
}

@ShowLoader()
export class LoadCountries implements Action {
    readonly type = CountriesActionTypes.LoadCountries;
    constructor() { }
}

@HideLoader(CountriesActionTypes.LoadCountries)
export class LoadCountriesSuccess implements Action {
    readonly type = CountriesActionTypes.LoadCountriesSuccess;
    constructor(public payload: Country[]) { }
}
@HideLoader(CountriesActionTypes.LoadCountries)
export class LoadCountriesFail implements Action {
    readonly type = CountriesActionTypes.LoadCountriesFail;
    constructor(public payload: string) { }
}

export type CountriesActions = LoadCountries | LoadCountriesSuccess | LoadCountriesFail;
